import { VerificationNames, DataVendors } from "shared/types";
import logo from "shared/branding/logo.svg";

export const getLogoSrc = (name: VerificationNames | DataVendors) => {
  switch (name) {
    case VerificationNames.HousingHistory:
      return logo;
    case VerificationNames.IdentityVerification:
      return "/assets/plaid_logo.svg";
    case VerificationNames.CreditReport:
      return "/assets/equifax_logo.svg";
    case DataVendors.CIC:
      return "/assets/cic_logo.svg";
    case DataVendors.Cleara:
      return "/assets/cleara_logo.svg";
    default:
      return;
  }
};
